import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  DragSource,
  DropTarget,
} from 'react-dnd';
import {
  Col,
  Row,
  Input,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { thumbnailPlaceholder } from '../../../helpers/Collections';
import ItemTypes from '../../../helpers/DNDItemTypes';
import {
  pageSectionCollectionsTarget,
  pageSectionCollectionsSource,
} from '../../../helpers/DNDPageSectionCollections';

const AdminPageEditCollectionsListItem = ({
  collection,
  isDragging,
  showTitle,
  showSubtitle,
  handleChangeCollection,
  handleDeleteCollection,
  connectDragSource,
  connectDropTarget,
}) => {
  const intl = useIntl();

  return (connectDragSource(connectDropTarget((
    <tr className={classnames({ dragging: isDragging })}>
      <td className="collection-image">
        <Link
          to={`/collections/${collection.uuid}`}
          target="_blank"
          className="list-item-img-wrapper"
        >
          {collection.featured_file ? (
            <img
              className="list-item-img"
              width="100%"
              src={collection.featured_file.urls.thumbnail}
              srcSet={`${collection.featured_file.urls.thumbnail} 1x, ${collection.featured_file.urls.thumbnailx2} 2x`}
              alt={collection.name}
            />
          ) : (
            <img
              className="list-item-img"
              width="100%"
              src={thumbnailPlaceholder}
              alt={collection.name}
            />
          )}
        </Link>
      </td>
      <th scope="row" className="collection-name">
        <Link to={`/collections/${collection.uuid}`} target="_blank">
          {collection.type === 'group' ? (
            <i className="far fa-layer-group" />
          ) : (
            <i className="far fa-clone" />
          )}&nbsp;
          {collection.name}
        </Link>
      </th>
      <td className="collection-fields">
        <Row form>
          {showTitle && (
            <Col>
              <Input
                type="text"
                id={`collection-title-${collection.id}`}
                name="title"
                placeholder={intl.formatMessage({ defaultMessage: 'Title' })}
                value={collection.title || ''}
                onChange={(e) => {
                  handleChangeCollection(e, collection);
                }}
              />
            </Col>
          )}
          {showSubtitle && (
            <Col>
              <Input
                type="text"
                id={`collection-subtitle-${collection.id}`}
                name="subtitle"
                placeholder={intl.formatMessage({ defaultMessage: 'Subtitle' })}
                value={collection.subtitle || ''}
                onChange={(e) => {
                  handleChangeCollection(e, collection);
                }}
              />
            </Col>
          )}
        </Row>
        <Row form>
          <Col>
            <Input
              type="text"
              id={`collection-custom-url-${collection.id}`}
              name="custom_url"
              placeholder={intl.formatMessage({ defaultMessage: 'Not-logged in link' })}
              value={collection.custom_url || ''}
              onChange={(e) => {
                handleChangeCollection(e, collection);
              }}
            />
          </Col>
        </Row>
      </td>
      <td className="action-more">
        <a
          href="#delete"
          id={`collection-delete-${collection.id}`}
          onClick={(e) => {
            e.preventDefault();
            handleDeleteCollection(collection.id);
          }}
        >
          <i className="far fa-trash" />
        </a>
        <UncontrolledTooltip target={`collection-delete-${collection.id}`} placement="left">
          {intl.formatMessage({ defaultMessage: 'Delete section' })}
        </UncontrolledTooltip>
      </td>
    </tr>
  ))));
};

AdminPageEditCollectionsListItem.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  collection: PropTypes.object.isRequired,
  isDragging: PropTypes.bool.isRequired,
  showTitle: PropTypes.bool.isRequired,
  showSubtitle: PropTypes.bool.isRequired,
  handleChangeCollection: PropTypes.func.isRequired,
  handleDeleteCollection: PropTypes.func.isRequired,
};

export default
DragSource(ItemTypes.PAGE_SECTION_ITEM, pageSectionCollectionsSource, (DNDconnect, monitor) => ({
  connectDragSource: DNDconnect.dragSource(),
  isDragging: monitor.isDragging(),
}))(DropTarget(ItemTypes.PAGE_SECTION_ITEM, pageSectionCollectionsTarget, DNDconnect => ({
  connectDropTarget: DNDconnect.dropTarget(),
}))(AdminPageEditCollectionsListItem));
